<div class="margin">
    <app-home-title-list-button
        [titleTranslocoKey]="'home.contacts.section_e.title'"
        [items]="items"
        [btnLabelTranslocoKey]="'home.contacts.section_e.button'"
        [isBtnFlat]="true"
    ></app-home-title-list-button>
</div>